<template>
  <v-app id="inspire">
    <v-container
      class="fill-height"
      fluid
    >
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          cols="12"
          sm="8"
          md="4"
        >
          <v-card class="elevation-12" v-show="isRegister">
            <v-toolbar
              color="primary"
              dark
              flat
            >
              <v-toolbar-title>Регистрация</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text class="p-4">
              <v-form>
                <v-text-field
                  label="Имя"
                  name="login"
                  :error-messages="errors['firstName'] || []"
                  prepend-icon="mdi-account"
                  type="text"
                  v-model="firstName"
                ></v-text-field>
                <v-text-field
                  :error-messages="errors['lastName'] || []"
                  label="Фамилия"
                  name="login"
                  prepend-icon="mdi-account"
                  type="text"
                  v-model="lastName"
                ></v-text-field>
                <v-text-field
                  :error-messages="errors['phoneNumber'] || []"
                  label="Номер телефона"
                  name="login"
                  prepend-icon="mdi-phone"
                  type="text"
                  v-model="phoneNumber"
                ></v-text-field>

                <v-text-field
                  id="password"
                  label="E-mail"
                  name="password"
                  prepend-icon="mdi-email"
                  type="email"
                  v-model="email"
                  :error-messages="errors['email'] || []"
                ></v-text-field>
                <v-text-field
                  id="password"
                  label="Пароль"
                  name="password"
                  prepend-icon="mdi-lock"
                  type="password"
                  v-model="password"
                  :error-messages="errors['password'] || []"
                ></v-text-field>
                <v-text-field
                  id="password"
                  label="Повторите пароль"
                  name="password"
                  prepend-icon="mdi-lock"
                  type="password"
                  v-model="passwordConfirmation"
                ></v-text-field>
              </v-form>
            </v-card-text>
            <v-spacer></v-spacer>
            <v-card-actions class="d-flex justify-space-between mb-6">
              <router-link  rel="nofollow" tag="a" :to="{name:'Login'}" class="border-bottom">
                Уже есть аккаунт ?
              </router-link>
              <v-btn color="primary" @click.prevent="register" :loading="loading">Создать аккаунт</v-btn>
            </v-card-actions>
          </v-card>
          <confirm-phone-component
            @successActivationCode='signIn'
            v-show="isConfirm"
            :number-phone="phoneNumber"
            :url-send="uriConfirmationPhone"
          >

          </confirm-phone-component>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
  import {
    ValidationObserver,
    ValidationProvider,
    withValidation
  } from "vee-validate";
  import ConfirmPhoneComponent from "./ConfirmPhoneComponent";

  const STATE_REGISTER = 'register';
  const STATE_CONFIRM_PHONE = 'confirm';
  const URI_CONFIRMATION_PHONE  = '/auth/signup/activate-phone';

  export default {
    props: {
      source: String,
    },
    components: {
      ValidationProvider,
      ValidationObserver,
      ConfirmPhoneComponent
    },
    created() {
      bus.$on('validationErrors', payload => this.errors = payload)
    },
    data() {
      return {
        uriConfirmationPhone : URI_CONFIRMATION_PHONE,
        state: STATE_REGISTER,
        errors: [],
        loading: false,
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        password: "",
        passwordConfirmation: ""
      }
    },
    computed:{
      isRegister(){
        return this.state === STATE_REGISTER;
      },
      isConfirm(){
        return this.state === STATE_CONFIRM_PHONE;
      }
    },
    methods: {
      resetLoading() {
        this.loading = false;
      },
      resetErrors() {
        this.errors = [];
      },
      signIn(){
        let data = {
          phone_number : this.phoneNumber,
          password : this.password
        }
        auth.login(data)
          .then((data) => {
            this.loading = false;
            this.$router.push({'path' : '/'})
          })
      },
      register() {
        let data = {
          email: this.email,
          password: this.password,
          password_confirmation: this.passwordConfirmation,
          phoneNumber: this.phoneNumber,
          firstName: this.firstName,
          lastName: this.lastName
        };

        if (this.loading) {
          return;
        }

        this.loading = true;
        auth.register(data)
          .then(({data}) => {
            this.state = STATE_CONFIRM_PHONE;
            this.resetLoading();
          })
          .catch(error => {
            this.loading = false;
            this.errors = error.response.data.errors;
            this.resetLoading();
          })
      }
    }
  }
</script>
<style>
  #inspire {
    background-color: #E0F2F1;
  }
</style>
